<template>
  <!-- 系统首页 -->
  <div class="index">
    <el-container>
      <el-aside style="width: 212px">
        <ul class="left_url_tab">
          <div class="li-title_1">
            <div style="float: left;">常见问题</div>
            <div style="float: right">更多帮助></div>
          </div>
          <!--<li class="li-title_1">常见问题</li>-->
          <li class="li-title_3">新手指南</li>
          <template v-for="item in issue">
            <el-tooltip
              class="item"
              effect="light"
              placement="top-start"
              :content="item"
            >
              <li class="li-title_2">{{ item }}</li>
            </el-tooltip>
          </template>

          <li class="li-title_2" style="padding: 5px 0 15px 0;">
            <div
              style="width: 85%;height: 90%;line-height: 22px;background: rgb(245 247 250);margin: 0 7%;text-align: center;border: 1px solid #c7c7c7;color: rgb(89, 90, 90);"
            >
              问题没解决？提交工单
            </div>
          </li>
        </ul>
        <ul class="left_url_tab">
          <li class="li-title_1">最近登陆</li>
          <div v-if="false">
            <!--todo 这里需自编写最近登陆记录信息-->
          </div>
          <div
            style="text-align: center;height: 50px;line-height: 50px;"
            v-else
          >
            暂无记录
          </div>
        </ul>
        <!--商品滚动播放-->
        <Broadcast></Broadcast>

        <ul class="left_url_tab" style="margin-top: 15px;">
          <li class="li-title_1">投诉邮箱</li>
          <div class="email">邮箱地址：<span>113xxx68@foxmail.com</span></div>
        </ul>
      </el-aside>

      <el-main class="el-main1">
        <div style="height: 195px;">
          <div class="div-agenda">
            <div class="li-title_1">待办事项</div>
            <div class="div-agenda-line">
              <div class="div-agenda-title">订单</div>
              <div class="div-agenda-text">
                <div>生产发货异常</div>
                <span style="font-weight: bold;">0</span>
              </div>
              <div class="div-agenda-text">
                <div>锁定中</div>
                <span style="font-weight: bold;">0</span>
              </div>
              <div class="div-agenda-text">
                <div>催单中</div>
                <span style="font-weight: bold;">0</span>
              </div>
            </div>
            <div class="div-agenda-line">
              <div class="div-agenda-title">订单</div>
              <div class="div-agenda-text">
                <div>运单生成异常</div>
                <span style="font-weight: bold;">0</span>
              </div>
              <div class="div-agenda-text">
                <div>运单生成中</div>
                <span style="font-weight: bold;">0</span>
              </div>
            </div>
          </div>
          <div class="div-operation">
            <div class="li-title_1">常用操作</div>
            <div class="operation-piece">
              <!--<i class="iconfont icon-blue" style="">&#xe622;</i>-->
              <div class="operation-main">
                <ul>
                  <li class="li-title_2">
                    <el-dropdown placement="right-start">
                      <span class="li-title_2"
                        ><i class="iconfont">&#xe606;</i>平台授权</span
                      >
                      <el-dropdown-menu slot="dropdown" placement="top">
                        <el-dropdown-item>[亚马逊]授权</el-dropdown-item>
                        <el-dropdown-item>[速卖通]授权</el-dropdown-item>
                        <el-dropdown-item>[Wish]授权</el-dropdown-item>
                        <el-dropdown-item>[Shopee]授权</el-dropdown-item>
                        <el-dropdown-item>[Lazada]授权</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </li>
                  <li class="li-title_2">
                    <el-dropdown placement="right-start">
                      <span class="li-title_2"
                        ><i class="iconfont">&#xe606;</i>创建产品</span
                      >
                      <el-dropdown-menu slot="dropdown" placement="top">
                        <el-dropdown-item>[亚马逊]产品汇出</el-dropdown-item>
                        <el-dropdown-item>[速卖通]产品汇出</el-dropdown-item>
                        <el-dropdown-item>[Wish]产品汇出</el-dropdown-item>
                        <el-dropdown-item>[Shopee]产品汇出</el-dropdown-item>
                        <el-dropdown-item>[Lazada]产品汇出</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </li>
                  <li class="li-title_2">
                    <i class="iconfont">&#xe67e;</i>选品管理
                  </li>
                  <li class="li-title_2">
                    <i class="iconfont" style="font-size: 12px;">&#xe615;</i
                    >我的图库
                  </li>
                </ul>
              </div>
              <div class="operation-main">
                <ul>
                  <li class="li-title_2">
                    <i class="iconfont">&#xe6bf;</i>订单导入
                  </li>
                  <li class="li-title_2">
                    <i class="iconfont">&#xe622;</i>账号充值
                  </li>
                  <li class="li-title_2">
                    <i class="iconfont">&#xe664;</i>我的工单
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="div-statistics">
          <div class="li-title_1">
            <div style="float: left;">
              <i class="iconfont icon">&#xe641;</i>数据统计
            </div>
            <div style="float: right;height: 98%">
              <div style="float: left; margin-right: 20px;">
                营业额统计范围：<span style="color: #409eff;">设置</span>
              </div>
              <div style="float: left;">显示币种：人名币</div>
            </div>
          </div>
          <div style="height: 80%;">
            <div class="statistics-main">
              <ul>
                <li class="statistics-main-li1">今日营业额</li>
                <li class="statistics-main-li1 statistics-main-li2">￥0</li>
                <li class="statistics-main-li3">
                  <div class="statistics-main-num">订单件数</div>
                  0
                </li>
                <li class="statistics-main-li3">
                  <div class="statistics-main-num">订单数</div>
                  0
                </li>
              </ul>
            </div>
            <div class="statistics-main">
              <ul>
                <li class="statistics-main-li1">昨日营业额</li>
                <li class="statistics-main-li1 statistics-main-li2">￥0</li>
                <li class="statistics-main-li3">
                  <div class="statistics-main-num">订单件数</div>
                  0
                </li>
                <li class="statistics-main-li3">
                  <div class="statistics-main-num">订单数</div>
                  0
                </li>
              </ul>
            </div>
            <div class="statistics-main">
              <ul>
                <li class="statistics-main-li1">待付款订单数</li>
                <li class="statistics-main-li1 statistics-main-li2">0</li>
                <li class="statistics-main-li3">
                  <div class="statistics-main-num">订单件数</div>
                  0
                </li>
                <li class="statistics-main-li3">
                  <div class="statistics-main-num">订单数</div>
                  0
                </li>
              </ul>
            </div>
            <div class="statistics-main">
              <ul>
                <li class="statistics-main-li1">待发货订单数</li>
                <li class="statistics-main-li1 statistics-main-li2">0</li>
                <li class="statistics-main-li3">
                  <div class="statistics-main-num">订单件数</div>
                  0
                </li>
                <li class="statistics-main-li3">
                  <div class="statistics-main-num">订单数</div>
                  0
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="div-warning">
          上传图片或/和文字时不得存在涉政、涉黄、侵权等违法行为，情节严重的将予以封号处理，感谢您的配合。【<span
            style="color: #409eff;cursor: pointer;"
            >更多</span
          >】
        </div>

        <div
          style="position: relative;height: 21rem;border: 1px solid #c7c7c7;margin-top: 13px;"
        >
          <div class="div-more">查看更多>></div>
          <el-tabs class="el-table-div" v-model="activeName" type="card">
            <el-tab-pane label="全部" name="first">
              <template>
                <el-table
                  :data="tableData"
                  style="width: 100%"
                  @row-click="noticeClick"
                >
                  <el-table-column
                    prop="noticeTitle"
                    label="公告标题"
                  ></el-table-column>
                  <el-table-column
                    prop="noticeType"
                    label="公告类型"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">{{
                      convert(scope.row.noticeType)
                    }}</template>
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="日期"
                    width="200"
                    align="center"
                  ></el-table-column>
                </el-table>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div
          style="position: relative;background: white;height: 32rem;border: 1px solid #c7c7c7;margin-top: 13px;"
        >
          <div class="div-more">查看更多>></div>
          <el-tabs
            class="el-table-div el-table-bc"
            v-model="activeName1"
            type="card"
            @tab-click="handleClick"
          >
            <el-tab-pane label="全部" name="chart-first">
              <div style="margin: 15px 10px;height: 21px;">
                <div style="float: left;width: 20%;">
                  统计类型：
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      销售金额<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>订单数</el-dropdown-item>
                      <el-dropdown-item>订单件数</el-dropdown-item>
                      <el-dropdown-item>销售金额</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div style="float: left;">
                  查看类型：
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      账号<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>平台</el-dropdown-item>
                      <el-dropdown-item>账号</el-dropdown-item>
                      <el-dropdown-item>店铺</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown trigger="click" style="width: 170px;">
                    <span class="el-dropdown-link">
                      全部<i
                        style="float: right;margin: 4px 4px 0 0;"
                        class="el-icon-arrow-down el-icon--right"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>全部</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div style="float: right;"></div>
              </div>
              <div class="myechartc" ref="chart-first"></div>
            </el-tab-pane>
            <el-tab-pane label="其他" name="chart-second">
              <div style="margin: 15px 10px;height: 21px;">
                <div style="float: left;width: 20%;">
                  统计类型：
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      销售金额<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>订单数</el-dropdown-item>
                      <el-dropdown-item>订单件数</el-dropdown-item>
                      <el-dropdown-item>销售金额</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div style="float: left;">
                  查看类型：
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      账号<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>平台</el-dropdown-item>
                      <el-dropdown-item>账号</el-dropdown-item>
                      <el-dropdown-item>店铺</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown trigger="click" style="width: 170px;">
                    <span class="el-dropdown-link">
                      全部<i
                        style="float: right;margin: 4px 4px 0 0;"
                        class="el-icon-arrow-down el-icon--right"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>全部</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div style="float: right;"></div>
              </div>
              <div class="myechartc" ref="chart-second"></div>
            </el-tab-pane>
            <el-tab-pane label="图库统计" name="chart-third">
              <div style="margin: 15px 10px;height: 21px;">
                <div style="float: left;">
                  账号：
                  <el-dropdown trigger="click" style="width: 170px;">
                    <span class="el-dropdown-link">
                      全部<i
                        style="float: right;margin: 4px 4px 0 0;"
                        class="el-icon-arrow-down el-icon--right"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>全部</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div style="float: right;"></div>
              </div>
              <div class="myechartc" ref="chart-third"></div>
            </el-tab-pane>
            <el-tab-pane label="产品统计" name="chart-fourth">
              <div style="margin: 15px 10px;height: 21px;">
                <div style="float: left;">
                  账号：
                  <el-dropdown trigger="click" style="width: 170px;">
                    <span class="el-dropdown-link">
                      全部<i
                        style="float: right;margin: 4px 4px 0 0;"
                        class="el-icon-arrow-down el-icon--right"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>全部</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div style="float: right;"></div>
              </div>
              <div class="myechartc" ref="chart-fourth"></div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <el-dialog :close-on-click-modal="false"  
          class="notice-dialog"
          title="系统公告"
          :visible.sync="noticeDialogVisible"
        >
          <div style="height: 500px">
            <div
              style="height: 40px;line-height: 40px;color: #434649;text-align: center;font-size: 16px;font-weight: 600"
            >
              {{ noticeDialogData.title }}
            </div>
            <div style="color: #7d8289;font-size: 13px;text-align: center">
              来源：xxx公告 {{ noticeDialogData.createTime }}
            </div>
            <div style="margin: 20px 10px;height: 400px;overflow: auto">
              <span v-html="noticeDialogData.content"></span>
            </div>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Broadcast from "@/components/common/Broadcast"
import echarts from "echarts"
import { listNotice } from "@/api/system/notice"
// require('echarts/theme/macarons')

export default {
  name: "index",
  components: { Broadcast },
  data() {
    return {
      value1: null,
      radio1: null,
      temp: "shanghai",
      noticeDialogVisible: false,
      /*新页面数据*/
      issue: [
        "其他平台平台已有产品（非系统自建）如何下单？",
        "如何导入订单？",
        "用E邮宝包邮到美国要多少钱？",
        "设计器基础功能介绍",
        "商品生产发货周期是多久？",
        "我能销售的产品有哪些？",
        "亚马逊店铺授权方法",
      ],
      agendaData: [{}],
      activeName: "first",
      activeName1: "chart-first",
      /*type_公告类型: 1_新品发布, 2_物流公告, 3_网站公告, 4_功能更新; icon图标：0_无小图标, 1_new新图标, 2_hot图标; */
      tableData: [],
      newData: [
        {
          title: "袜子40cm（多双设计）",
          type: 1,
          dateTime: "2021-01-09 08:06:54",
          icon: 1,
        },
        {
          title: "成年防尘防寒口罩（4个款）",
          type: 1,
          dateTime: "2021-01-08 18:26:04",
          icon: 1,
        },
        {
          title: "绒球边毛毯",
          type: 1,
          dateTime: "2021-01-08 17:56:28",
          icon: 1,
        },
        {
          title: "地毯三件套系列（不同设计）",
          type: 1,
          dateTime: "2021-01-08 16:54:41",
          icon: 1,
        },
        {
          title: "口罩多个设计系列",
          type: 1,
          dateTime: "2021-01-06 21:36:50",
          icon: 1,
        },
        {
          title: "餐巾布50*50cm",
          type: 1,
          dateTime: "2021-01-06 07:21:00",
          icon: 1,
        },
      ],
      logData: [
        {
          title: "关于顺丰国际物流资费调整公告",
          type: 2,
          dateTime: "2021-01-09 08:06:54",
          icon: 1,
        },
        {
          title:
            "关于E邮宝（空运）云途、递四方、义达、嘉时派等物流资费调整公告",
          type: 2,
          dateTime: "2021-01-08 18:26:04",
          icon: 1,
        },
        {
          title: "关于Jaspost嘉时派USPS标快-普货物流寄运重量调整通知",
          type: 2,
          dateTime: "2021-01-08 17:56:28",
          icon: 1,
        },
        {
          title: "关于Wish邮-EUB物流方式切换为线上结算的说明",
          type: 2,
          dateTime: "2021-01-08 16:54:41",
          icon: 1,
        },
        {
          title: "关于顺丰国际物流资费调整公告",
          type: 2,
          dateTime: "2021-01-06 21:36:50",
          icon: 1,
        },
        {
          title: "关于云途、鑫佳达物流资费调整公告",
          type: 2,
          dateTime: "2021-01-06 07:21:00",
          icon: 1,
        },
      ],
      webData: [
        {
          title: "网站维护公告",
          type: 3,
          dateTime: "2021-01-09 08:06:54",
          icon: 1,
        },
        {
          title: "2021新年开门红，指纹产品惊爆价活动公告",
          type: 3,
          dateTime: "2021-01-08 18:26:04",
          icon: 1,
        },
        {
          title: "元旦假期各物流商、生产商及指纹平台放假安排",
          type: 3,
          dateTime: "2021-01-08 17:56:28",
          icon: 1,
        },
        {
          title: "关于Jaspost嘉时派USPS标快物流渠道及资费调整公告",
          type: 3,
          dateTime: "2021-01-08 16:54:41",
          icon: 1,
        },
      ],
      funData: [
        {
          title: "关于各平台支持自定义图片汇出尺寸功能更新说明",
          type: 4,
          dateTime: "2021-01-09 08:06:54",
          icon: 1,
        },
        {
          title: "关于亚马逊图片域名调整、速卖通多变种合并顺序等功能更新说明",
          type: 4,
          dateTime: "2021-01-08 18:26:04",
          icon: 1,
        },
        {
          title: "关于订单列表“设置销售金额”权限和消息中心的调整说明",
          type: 4,
          dateTime: "2021-01-08 17:56:28",
          icon: 1,
        },
        {
          title: "关于移动端账户充值、Shopee多变种等功能更新说明",
          type: 4,
          dateTime: "2021-01-08 16:54:41",
          icon: 1,
        },
        {
          title:
            "关于设计器新增背景取色和字体描边、产品显示特货类型等功能更新说明",
          type: 4,
          dateTime: "2021-01-06 21:36:50",
          icon: 1,
        },
        {
          title: "关于订单销售总计、报关信息修改等功能优化说明",
          type: 4,
          dateTime: "2021-01-06 07:21:00",
          icon: 1,
        },
      ],
      noticeDialogData: {
        title: null,
        createTime: null,
        content: null,
      },
    }
  },
  created() {
    this.loadNoticeData()
  },
  mounted() {
    this.initChart("chart-first")
  },

  methods: {
    handleClick(tab, event) {
      let id = tab.name
      this.initChart(id)
    },

    /* Echarts */
    initChart(id) {
      let myChart = echarts.init(this.$refs[id], "macarons")

      let option = {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["全部"],
        },
        grid: {
          // top: '10%',
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "2021-01-11",
            "2021-01-12",
            "2021-01-13",
            "2021-01-14",
            "2021-01-15",
            "2021-01-16",
            "2021-01-17",
            "2021-01-18",
            "2021-01-19",
            "2021-01-20",
            "2021-01-21",
            "2021-01-22",
            "2021-01-23",
            "2021-01-24",
            "2021-01-25",
          ],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "全部",
            type: "line",
            stack: "总量",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      }
      myChart.setOption(option)
    },

    /*公告类型常量转换*/
    convert(type) {
      let typeName = "未知"
      switch (type) {
        case "1":
          typeName = "通知"
          break
        case "2":
          typeName = "公告"
          break
        default:
          break
      }
      return typeName
    },

    // 获取公告数据
    loadNoticeData() {
      listNotice({ status: "0" })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.rows
            if (res.rows.length > 0) {
              this.noticeDialogData.title = res.rows[0].noticeTitle
              this.noticeDialogData.content = res.rows[0].noticeContent
              this.noticeDialogData.createTime = res.rows[0].createTime
            }
            this.noticeDialogVisible = true
          }
        })
        .catch()
    },
    noticeTypeFormat(val) {
      if (val == "1") {
        return "通知"
      } else if (val == "2") {
        return "公告"
      }
    },
    noticeClick(row, col, e) {
      this.noticeDialogData.title = row.noticeTitle
      this.noticeDialogData.content = row.noticeContent
      this.noticeDialogData.createTime = row.createTime
      this.noticeDialogVisible = true
    },
  },
}
</script>

<style scoped>
@import "../assets/css/order.css";
@import "../assets/css/iconfont/iconfont.css";

.order_index {
  width: 100%;
}
.index {
  height: 100%;
  width: 100%;
  font-size: 12.5px;
  color: #000000b5;
}

.el-container {
  height: 100%;
}

.el-main1 {
  /*background-color: rgba(245, 245, 245, 1);*/
  padding: 0px;
  /*min-width: 1500px;*/
  overflow: hidden;
}

.left_url_tab {
  border: 1px solid #c7c7c7;
  margin-top: 0;
  /*font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;*/
  background: white;
}
.left_url_tab li:not(:last-child) {
  list-style: none;
  /*border-bottom: 1px solid #EBEEF5;*/
}

.li-title_1 {
  height: 37px;
  line-height: 37px;
  background-color: #c1c1c154;
  vertical-align: top;
  padding: 0 7px;
  font-weight: bold;
  color: #000000b5;
  border-bottom: 1px solid #c7c7c7;
}
.li-title_2 {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  padding-left: 10px;
  color: #409eff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.li-title_3 {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  padding-left: 10px;
  color: #e2c316;
  font-size: 11.5px;
  cursor: pointer;
}
.li-title_2:hover {
  /*background-color: #409eff;*/
  color: black;
  cursor: pointer;
}
.li-help {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  text-align: center;
  font-size: 16px;
}
.li-help a {
  text-decoration: none;
  color: #409eff;
}

/*新首页css--START*/
.left_url_tab .item {
  /*margin: 4px;*/
}
.email {
  text-align: center;
  height: 50px;
  line-height: 50px;
  font-size: 12px;
}
.email span {
  color: #409eff;
}
.email span:hover {
  color: #000000b5;
  cursor: pointer;
}

.div-agenda {
  float: left;
  width: 69.1%;
  height: 100%;
  background: white;
  margin-right: 1%;
  border: 1px solid #c7c7c7;
}
.div-agenda .div-agenda-line {
  width: 92%;
  height: 38%;
  line-height: 74px;
  margin-left: 1%;
  padding: 0 3%;
  border-bottom: 1px solid #c7c7c7;
}
.div-agenda-line .div-agenda-title {
  width: 13%;
  font-weight: bold;
  float: left;
}
.div-agenda-line .div-agenda-text {
  float: left;
  width: 29%;
}
.div-agenda-text div {
  width: 35%;
  float: left;
}
.div-agenda-text span {
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}

.div-operation {
  float: left;
  width: 29.5%;
  height: 100%;
  background: white;
  border: 1px solid #c7c7c7;
}
.operation-piece {
  width: 90%;
  height: 80%;
  padding: 0 5%;
}

.operation-main {
  float: left;
  width: 50%;
}
.operation-main ul {
  padding-left: 0;
}
.operation-main li {
  height: 33px;
}
.operation-main span {
  padding-left: 0;
  font-size: 12.5px;
}
.operation-main i {
  padding-right: 10px;
}

.div-statistics {
  height: 210px;
  margin-top: 13px;
  background: white;
  border: 1px solid #c7c7c7;
}

.statistics-main {
  width: 21%;
  height: 70%;
  float: left;
  margin: 1.65% 0 1.65% 3.2%;
  border-radius: 8px;
  box-shadow: 0px 0px 11px 3px rgba(0, 0, 0, 0.24);
}
.statistics-main ul {
  padding-left: 7%;
  line-height: 23px;
}
.statistics-main-li1 {
  list-style: none;
  font-size: 12.5px;
  font-weight: bold;
  color: #0000008c;
}
.statistics-main-li2 {
  font-size: 20px;
  color: #000000b5;
}
.statistics-main-li3 {
  list-style: none;
  font-size: 12px;
  color: darkgrey;
}
.statistics-main-li1:hover,
.statistics-main-li3:hover {
  color: #409eff;
  cursor: pointer;
}
.statistics-main-num {
  float: left;
  width: 19%;
}

.el-menu {
  height: 100%;
  background: rgba(0, 0, 0, 0) !important;
}
.el-menu--horizontal > .el-menu-item {
  height: 100% !important;
  line-height: 38px !important;
}
.el-menu--horizontal > .el-submenu > .el-submenu__title {
  height: 100% !important;
  line-height: 38px !important;
}

.div-warning {
  height: 37px;
  line-height: 37px;
  background-color: #fff8e5;
  padding: 0 10px;
  font-weight: bold;
  color: #c29030;
  border: 1px solid #ffd791;
  margin-top: 13px;
}

.el-table-div {
  height: 100%;
  background: white;
}
.el-table-div >>> .el-tab-pane {
  margin: 0 10px;
}
.el-table-div >>> .el-tabs__header {
  margin: 0 !important;
}
.el-table-div >>> .el-table thead {
  color: #000000b5;
  font-weight: bold;
  font-size: 13px;
}
.el-table-div >>> .el-table th {
  padding: 8px 0 0 0 !important;
  border-bottom: 1px solid white;
}
.el-table-div >>> .el-table th div {
  background: #f5f7fa;
  padding-top: 4px;
  padding-bottom: 4px;
}
.el-table-div >>> .el-table td {
  padding: 8px 0 !important;
}
.el-table-div >>> .el-table__row:hover {
  cursor: pointer;
}
.el-table-div >>> .el-table__row td:first-child:hover {
  color: #000000b5;
}
.el-table-div >>> .el-table__row td:first-child {
  color: #409eff;
  cursor: pointer;
}

.el-table-bc {
  height: 97.5% !important;
  border-bottom: 1px solid rgb(199, 199, 199);
}
.el-table-bc >>> .el-dropdown {
  border: 1px solid #c1c1c1;
  border-radius: 3px;
  margin-left: 5px;
  cursor: context-menu;
}

.div-more {
  color: rgb(132 122 255);
  float: right;
  position: absolute;
  right: 10px;
  top: 13px;
  z-index: 9;
}
.div-more:hover {
  color: #000000b5;
  cursor: pointer;
}
.el-table-bc .myechartc {
  height: 380px;
  width: 1590px;
  margin-top: 20px;
}

/*icon--Start*/
.icon {
  margin-right: 5px;
  color: #8e8e8e;
}
/*icon-End*/
/*.notice-dialog >>> img{width: 100%;height: auto}*/
/*新首页css--END*/
</style>
